﻿import * as $ from "jquery";
import { StatusBarWidget } from "./StatusBar";
import { Loader } from "./loader";

export class Service {
    private baseUrl: string;
    private element: HTMLElement;
    constructor(baseUrl: string, parent: HTMLElement) {
        this.baseUrl = baseUrl;
        this.element = parent;
    }

    public DownloadAsync(url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onDownloadDone())
            .fail((xhr, status, error) => this.onDownloadFail(xhr, status, error, statusBarWidget));
    }



    public GetViewAsync(url: string, el: JQuery<HTMLElement>, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "html",
            contentType: 'application/x-www-form-urlencoded',
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onGetAsyncDone(html, el))
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error, statusBarWidget));
    }
    public GetView(url: string, el: JQuery<HTMLElement>, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "html",
            contentType: 'application/x-www-form-urlencoded',
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onGetDone(html, el))
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error, statusBarWidget));
    }
    public GetJson(url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "application/json",
            contentType: 'application/x-www-form-urlencoded',
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        });
    }
    public PostFile(data: any, el: JQuery<HTMLElement>, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            contentType: false,
            processData: false,
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onPostViewDone(html, el, statusBarWidget))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostFileAsync(data: any, el: JQuery<HTMLElement>, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            contentType: false,
            processData: false,
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onPostAsyncDone(html, el, statusBarWidget))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostObject(data: any, el: JQuery<HTMLElement>, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            contentType: "application/x-www-form-urlencoded",
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onPostViewDone(html, el, statusBarWidget))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostView(data: any, el: JQuery<HTMLElement>, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            contentType: "application/json",
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((html) => this.onPostViewDone(html, el, statusBarWidget))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostFileJson(data: any, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "json",
            contentType: false,
            processData: false,
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((result) => this.onPostDone(result))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostJson(data: any, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "json",
            processData: false,
            contentType: 'application/json',
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*'
            //},
        }).done((result: any) => this.onPostDone(result))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }
    public PostViewAsync(data: any, el: JQuery<HTMLElement>, url: string, statusBarWidget: StatusBarWidget) {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            contentType: "application/x-www-form-urlencoded",
            data: data,
            cache: false,
            xhrFields: {
                withCredentials: true
            }
            //headers: {
            //    'Access-Control-Allow-Origin': '*',
            //    'Content-Type': 'application/json'
            //},
        }).done((html) => this.onPostAsyncDone(html, el, statusBarWidget))
            .fail((xhr, status, error) => this.onPostFail(xhr, status, error, statusBarWidget));
    }

    onDownloadDone() {

    }

    onDownloadFail(xhr: JQueryXHR, status: any, error: any, statusBarWidget: StatusBarWidget) {
        try {
            let err = decodeURIComponent(atob(xhr.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
            if (!xhr.getResponseHeader("err"))
                location.reload();
        } catch (e) {
            location.reload();
        }
    }

    onGetDone(html: any, el: JQuery<HTMLElement>) {
        el.html(html);
        try { window.scroll({ top: el.offset().top - 20, left: 0 }); }
        catch { }
        this._hideLoader();
    }
    onGetAsyncDone(html: any, el: JQuery<HTMLElement>) {
        el.append(html);
        this._hideLoader();
    }
    onGetFail(xhr: JQueryXHR, status: any, error: any, statusBarWidget: StatusBarWidget) {

        try {
            let err = decodeURIComponent(atob(xhr.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
            if (!xhr.getResponseHeader("err"))
                location.reload();
        } catch (e) {
            location.reload();
        }
    }
    onPostDone(result: any) {
        this._hideLoader();
        return result;
    }
    onPostViewDone(html: any, el: JQuery<HTMLElement>, statusBarWidget: StatusBarWidget) {
        if(el!=null) el.html(html);
        this._hideLoader();
        return html;
    }
    onPostAsyncDone(html: any, el: JQuery<HTMLElement>, statusBarWidget: StatusBarWidget) {
        el.append(html);
        this._hideLoader();
    }
    onPostFail(xhr: JQueryXHR, status: any, error: any, statusBarWidget: StatusBarWidget) {
        try {
            let err = decodeURIComponent(atob(xhr.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
            if (!xhr.getResponseHeader("err"))
                location.reload();
        } catch (e) {
            location.reload();
        }
    }
    _showLoader() {
        Loader.showLoader(this.element);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
}